/**
 * Checks if any given value of x has a value, when it's an array it  checks the length
 * before that checks for null and undefined
 * @param x The subject in which we're chekcing the value
 */
export function hasValue(x: any): boolean {
  // null or undefined
  if (x === null || typeof x === 'undefined') {
    return false;
  }

  if (typeof x === 'string' && x === '') {
    return false;
  }

  const isDate = typeof x.getMonth === 'function';
  if (isDate) {
    return true;
  }
  // need to check if not date because a "Date" object in javascript returns 'object' when using typeof
  const isObject = !isDate && typeof x === 'object';
  if (isObject) {
    return Object.keys(x).length !== 0;
  }

  // check is array && empty
  if (Array.isArray(x) && x.length === 0) {
    return false;
  }

  return true;
}
